"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_modals_1 = require("@hotelplan/components.common.modals");
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const libs_hooks_dom_1 = require("@hotelplan/libs.hooks-dom");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const AutocompleteComboboxProvider_1 = __importDefault(require("./AutocompleteComboboxProvider"));
const AutocompleteInput_1 = __importDefault(require("./AutocompleteInput"));
const AutocompleteMobileModal_1 = __importDefault(require("./AutocompleteMobileModal"));
const AutocompleteSuggestion_1 = __importDefault(require("./AutocompleteSuggestion"));
const AutocompleteSuggestions_1 = __importDefault(require("./AutocompleteSuggestions"));
const AutocompleteTriggerInput_1 = __importDefault(require("./AutocompleteTriggerInput"));
const AutocompleteAbsoluteDropdown = (0, styled_components_1.default)(components_common_modals_1.AbsoluteDropdown)({
    width: '100%',
    top: 0,
    left: 0,
});
function onSuggestionClickDefault(item, ctx) {
    ctx.selectItem(item);
}
function AutocompleteComboboxInput(props) {
    const { travelDestinationConfig, controlRef, children, name, icon, label, placeholder, value: incomingValue = [], displayValue, getTagName, renderTagLabel, renderSuggestion, caption, noMobileControls, customLabel, onChange: incomingOnChange = noop_1.default, onOpen, onClose, onCancel, onApply, onOptionSelect, onOptionRemove, onSuggestionClick = onSuggestionClickDefault, className } = props, providerProps = __rest(props, ["travelDestinationConfig", "controlRef", "children", "name", "icon", "label", "placeholder", "value", "displayValue", "getTagName", "renderTagLabel", "renderSuggestion", "caption", "noMobileControls", "customLabel", "onChange", "onOpen", "onClose", "onCancel", "onApply", "onOptionSelect", "onOptionRemove", "onSuggestionClick", "className"]);
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    const contextRef = (0, react_1.useRef)(null);
    const dropDownWrapperRef = (0, react_1.useRef)(null);
    const [isOpened, openOriginal, close] = (0, libs_hooks_react_1.useToggleState)(false);
    const { autocompleteContextRef, disableAutocompleteTags, disableMobileOverlay, closePopupAfterSelect, iconProps, suggestionsExtraButton, } = travelDestinationConfig || {};
    if (autocompleteContextRef) {
        autocompleteContextRef.current = contextRef.current;
    }
    // Intermediate state
    const { isChanged, value, onChange, onApply: onApplyState, } = (0, libs_hooks_react_1.useIntermediateState)(incomingValue, incomingOnChange, !mobile || disableAutocompleteTags);
    function resetValue() {
        var _a;
        (_a = contextRef.current) === null || _a === void 0 ? void 0 : _a.setValue('');
    }
    const open = (0, react_1.useCallback)(() => {
        openOriginal();
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    }, [onOpen, openOriginal]);
    const onMobileApply = () => {
        requestAnimationFrame(() => {
            setTimeout(() => {
                var _a;
                resetValue();
                onApplyState();
                onApply === null || onApply === void 0 ? void 0 : onApply(((_a = contextRef.current) === null || _a === void 0 ? void 0 : _a.selectedItems) || []);
                close();
            }, 10);
        });
    };
    const onMobileClose = () => {
        var _a;
        (_a = contextRef.current) === null || _a === void 0 ? void 0 : _a.setSelected(incomingValue);
        resetValue();
        close();
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    const onDesktopClose = () => {
        resetValue();
        close();
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    const popupControl = {
        open,
        close: mobile ? onMobileClose : onDesktopClose,
        apply: mobile ? onMobileApply : onDesktopClose,
    };
    const onItemSelect = onOptionSelect
        ? ({ item, value: currentValue }) => {
            onOptionSelect(item, currentValue || '', popupControl);
            closePopupAfterSelect && close();
        }
        : undefined;
    const onItemRemove = onOptionRemove
        ? (item) => {
            var _a;
            onOptionRemove(item, ((_a = contextRef.current) === null || _a === void 0 ? void 0 : _a.value) || '', popupControl);
        }
        : undefined;
    if (controlRef) {
        controlRef.current = popupControl;
    }
    (0, libs_hooks_dom_1.useOnClickOutside)(dropDownWrapperRef, onDesktopClose, (!mobile || disableMobileOverlay) && isOpened);
    (0, libs_hooks_dom_1.useOnFocusOutside)(dropDownWrapperRef, onDesktopClose, (!mobile || disableMobileOverlay) && isOpened);
    (0, react_1.useEffect)(() => {
        if (isOpened) {
            // Trigger focus on next frame to prevent keyboard jumping
            requestAnimationFrame(() => {
                var _a;
                (_a = contextRef.current) === null || _a === void 0 ? void 0 : _a.focusInput();
            });
        }
    }, [isOpened]);
    const triggerInput = (react_1.default.createElement(AutocompleteTriggerInput_1.default, { onInteract: open, icon: icon ? icon : { name: 'planet' }, iconProps: iconProps, label: label, customLabel: customLabel, placeholder: placeholder, displayValue: displayValue, className: className, caption: caption }));
    const searchContent = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AutocompleteInput_1.default, { getTagName: getTagName, renderTagLabel: renderTagLabel, placeholder: placeholder, disableAutocompleteTags: disableAutocompleteTags, iconProps: iconProps }),
        children,
        react_1.default.createElement(AutocompleteSuggestions_1.default, { suggestionsExtraButton: suggestionsExtraButton }, (item, ctx, active) => (react_1.default.createElement(AutocompleteSuggestion_1.default, { active: active, onClick: () => onSuggestionClick(item, ctx, popupControl) }, renderSuggestion(item, ctx.value, active))))));
    return (react_1.default.createElement(AutocompleteComboboxProvider_1.default, Object.assign({ contextRef: contextRef, selectedItems: value, onSelectedChange: onChange, onItemSelect: onItemSelect, onItemRemove: onItemRemove }, providerProps, { className: className }),
        (!mobile || disableMobileOverlay) && (react_1.default.createElement(components_common_modals_1.DropDownWrapper, { className: className, ref: dropDownWrapperRef },
            triggerInput,
            react_1.default.createElement(AutocompleteAbsoluteDropdown, { className: "autocomplete-dropdown", isShown: isOpened }, searchContent))),
        mobile && !disableMobileOverlay && (react_1.default.createElement(react_1.default.Fragment, null,
            triggerInput,
            react_1.default.createElement(AutocompleteMobileModal_1.default, { name: name, label: label, show: isOpened, disableApply: !isChanged, noControls: noMobileControls, onOpen: onOpen, onApply: onMobileApply, onClose: onMobileClose }, searchContent)))));
}
exports.default = AutocompleteComboboxInput;
//# sourceMappingURL=AutocompleteComboboxInput.js.map